import { type CardStylingDataStructure } from 'javascripts/shared-types';
import CardStyling from '../CardStyling';
import { type CardLayoutModelType } from '../types';
import { type CardStylingTypesEnum_value } from 'components/framework/models/generated/types';

export class NoStyling extends CardStyling {
  static type: CardStylingTypesEnum_value = 'NoStyling';
  static title: string = 'None';

  exampleCardStyling() {
    return { highlightColor: '' };
  }

  cardStyling(record: CardLayoutModelType): CardStylingDataStructure {
    return { highlightColor: '' };
  }
}
